var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-layout-content',{staticClass:"content"},[_c('div',{ref:"ref_content_body",staticClass:"content-body"},[_c('div',{class:{ 'layout-2': _vm.layout !== 'Layout3', 'layout-3': _vm.layout === 'Layout3' }},[_c('keep-alive',{attrs:{"include":"photo"}},[_c('router-view',{staticStyle:{"height":"100%"}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }